import type { IOrderAddress, IShippingRequestAddress } from '@rogue/universal'
import { FORTY_EIGHT_STATES, AU_STATES } from '@/js/helpers/validations/shipping-zones'
import type { IRogue } from '@/js/services/RogueTypes'

export const check48States = (shippingAddress: IShippingRequestAddress | IOrderAddress) => !FORTY_EIGHT_STATES.includes(shippingAddress.region || '')
export const checkAUStates = (shippingAddress: IShippingRequestAddress | IOrderAddress) => !AU_STATES.includes(shippingAddress.region || '')

export const checkShippingAddress = (shippingAddress: IShippingRequestAddress | IOrderAddress, rogue: IRogue) => {
  if (shippingAddress.countryId) {
    if (rogue.site.code === 'USA' && shippingAddress.countryId === 'US') {
      if (shippingAddress.region) {
        return !check48States(shippingAddress)
      }

      return true
    }
    if (rogue.site.code === 'AUS') {
      if (shippingAddress.region) {
        return !checkAUStates(shippingAddress)
      }

      return true
    }
    if (['EUR', 'GBR'].includes(rogue.site.code)) {
      return true
    }

    return false
  }

  return true
}
